export default function notAgreementTerms(terms, optional = false) {
  return terms.filter((term) => {
    if (!optional && !term.required) return false;
    const rev = term?.current_revision;
    if (!rev?.agreement) return true;
    if (rev?.agreement?.term_revision_number != rev?.number) return true;
  });
}
